import { FunctionComponent } from "react";
import { useNavigate } from "react-router-dom";
import { ProfileModal } from "./ProfileModal";

/**
 * Route-level component for the /profile deep-link.
 * Renders the ProfileModal always open; closing navigates to /clients.
 * Normal in-app access uses ProfileModal directly via TopNav without routing.
 */
export const ProfilePage: FunctionComponent = () => {
    const navigate = useNavigate();

    return <ProfileModal isOpen={true} onClose={() => navigate("/clients", { replace: true })} />;
};
